import { render, staticRenderFns } from "./JBigFileUpload.vue?vue&type=template&id=15f162f0&scoped=true&"
import script from "./JBigFileUpload.vue?vue&type=script&lang=js&"
export * from "./JBigFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./JBigFileUpload.vue?vue&type=style&index=0&id=15f162f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f162f0",
  null
  
)

export default component.exports